import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface EmailFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  placeholder: CultureTextModel[] | string;
  type: FieldType.EmailAddress;
  sendReceipt: boolean;
}
export class EmailField extends BaseField implements EmailFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.EmailAddress = FieldType.EmailAddress;
  public sendReceipt = true;

  constructor(cultures: string[]) {
    super(FieldType.EmailAddress, cultures);

    this.defaultValue = [];
    this.placeholder = [];
    for (const culture of cultures) {
      this.defaultValue.push({ culture, value: '' });
      this.placeholder.push({ culture, value: '' });
    }
  }
}
